import React, {useContext} from "react";
import { Flex, Link, List, ListItem, Text, useToast } from "@chakra-ui/react";
import { AppContext } from "context/AppContext";

export default function Footer() {
  const { setTermsState, setPrivacyState} = useContext(AppContext);
  const toast = useToast()
  return (
    <Flex
      as="footer"
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      display={{
        xl:"flex",
        sm:"none"
      }}
      justifyContent="space-between"
      px="30px"
      pb="20px"
      position="fixed"
      bottom="0" 
      bg="#f7f8fc" 
      zIndex="100"
      width="-webkit-fill-available"
    >
      <Text color="gray.400" textAlign={{ base: "center", xl: "start" }}>
        Copyright &copy; 2023 - {1900 + new Date().getYear()}. GRID Platform Inc. All rights reserved.
      </Text>
      <List display="flex">
        <ListItem mr={{ base: "20px", md: "44px" }}>
          <Link color="gray.400"
            onClick={() =>
              toast({
                title: `This is Coming Soon`,
                position: 'top',
                isClosable: true,
              })} >HomePage</Link>
        </ListItem>
        <ListItem mr={{ base: "20px", md: "44px" }}>
          <Link color="gray.400"
            onClick={() =>
              toast({
                title: `This is Coming Soon`,
                position: 'top',
                isClosable: true,
              })} >License</Link>
        </ListItem>
        <ListItem mr={{ base: "20px", md: "44px" }}>
          <Link color="gray.400"
            onClick={()=>setTermsState(true)}
           >Terms of Use</Link>
        </ListItem>
        <ListItem>
          <Link color="gray.400" 
            onClick={()=>setPrivacyState(true)}
            >Privacy Policy</Link>
        </ListItem>
      </List>
    </Flex>
  );
}
